const imgTeamGraphic2Poster4 = "./assets/figma/06744399-888e-4094-a77f-3c9a1652fb48.png";
const img12032 = "./assets/figma/7f2a7ce8-be0d-428a-8606-8c1344abe439.png";
const img2026923382 = "./assets/figma/221a0709-28db-4d8c-a722-6c06f1ed6284.png";
const img2026923372 = "./assets/figma/06d5533b-ffa3-4942-a40c-4910afc87dee.png";
const img2026923373 = "./assets/figma/01051303-3827-4a66-ab58-6b9c95b95078.png";
const img2026923383 = "./assets/figma/418cccde-c404-479a-9d33-5dd4ffac3b77.png";
const img2026923384 = "./assets/figma/499d08db-cdaa-42da-9329-1fa92527a224.png";
const img2026923385 = "./assets/figma/10b9af6d-7016-4cc1-bdab-56e95e2535e6.png";
const imgRectangle245 = "./assets/figma/0470d51d-5596-4e3f-9712-8c5cae2ec5cf.png";
const imgUntitled111Png1 = "./assets/figma/4be6aa1b-34c7-4a5f-9968-8092b0fbafee.png";
const imgKakaoTalkPhoto20260915004836Png1 = "./assets/figma/1ea5d289-a38e-408c-b92f-a26175ea7aeb.png";
const imgKakaoTalkPhoto202609151531550011 = "./assets/figma/bac481f6-bf79-4077-97a3-4118cc2e86f8.png";
const imgKakaoTalkPhoto202609151531560021 = "./assets/figma/2a9fd92a-c813-4a83-a669-ac96aa3a3d10.png";
const img2 = "./assets/figma/d90cfaff-54d9-40fe-b656-8672b2217e0e.png";
const imgLine21 = "./assets/figma/024cae05-40d5-40cd-8187-3cfbbb55f6fe.svg";
const img1 = "./assets/figma/12bba834-9dfb-408a-831d-4e0f805933eb.svg";
const imgLine25 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgLine26 = "./assets/figma/004e04b2-2999-4bf9-a0ef-7d979948c643.svg";
const imgLine27 = "./assets/figma/05a65c31-9eb5-4b95-a7ed-46d18eb9cd91.svg";
const imgRectangle246 = "./assets/figma/5739c19d-a8c6-4a57-b818-fdb5339a6092.svg";
const imgRectangle247 = "./assets/figma/99e09d76-9d1a-40f9-a7b6-5916ffc59faa.svg";
const imgClose = "./assets/figma/174672c4-a815-4d5e-883b-923114b2b971.svg";

export default function TeamGraphic2Poster4() {
  return (
    <div className="s0 s1" data-node-id="875:2457" data-name="TEAM_GRAPHIC_2/POSTER4">
      <div aria-hidden className="s2 s3 s4">
        <div className="s2 s5 s3" />
        <div className="s2 s3 s6">
          <img alt="" className="s2 s7 s661 s9 s10 s662" src={imgTeamGraphic2Poster4} />
        </div>
      </div>
      <div className="s2 s12 s663 s14 s15" data-node-id="875:2459" data-name="image 14" />
      <div className="s2 s16 s17 s18 s19 s664 s786 s22" data-node-id="875:2460">
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s30" data-node-id="875:2461">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2462">
            PROJECT OVERVIEW
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2463">
            POSTERS · A2 · 4<br aria-hidden />
            GUIDE CARDS · 160 × 100 MM · 9<br aria-hidden />
            POSTCARDS · 100 × 150 MM · 8<br aria-hidden />
            <br aria-hidden />
          </p>
        </div>
        <div className="s17 s41 s18 s42 s0 s28 s43" data-node-id="875:2464">
          <div className="s44 s45">
            <div className="s46 s0 s47">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine21} />
              </div>
            </div>
          </div>
        </div>
        <div className="s23 s16 s17 s24 s25 s26 s27 s0 s28 s29 s50" data-node-id="875:2465">
          <p className="s31 s32 s0 s28 s33 s34" data-node-id="875:2466">
            MEMBERS
          </p>
          <p className="s35 s39 s0 s28 s37 s34" data-node-id="875:2467">
            강다원
            <br aria-hidden />
            고이룸
            <br aria-hidden />
            박성연
            <br aria-hidden />
            박세현
          </p>
        </div>
      </div>
      <p className="s23 s2 s51 s32 s52 s27 s29 s33 s787 s54" data-node-id="875:2468">
        LET THE IDEAS ROLL, PLAY THE LAB
      </p>
      <div className="s23 s2 s16 s17 s24 s25 s26 s665 s27 s29 s788 s57" data-node-id="875:2469">
        <p className="s31 s32 s0 s28 s58 s59" data-node-id="875:2470">
          ABOUT
        </p>
        <div className="s35 s36 s0 s28 s37 s59 s38" data-node-id="875:2471">
          <p className="s39 s40">{`그래픽 2팀은 유리관을 연결하고 조립한 타이포그래피로 DING AI LAB의 이름과 실험실이라는 공간적 특성을 시각화했다. `}</p>
          <p className="s39 s40">{`기하학적 형태와 색의 그라데이션이 겹치고 어우러지는 배경을 통해 다양한 아이디어가 모여 조화를 이루는 모습을 표현했으며, `}</p>
          <p className="s39 s40">{`텍스트를 그래픽과 연결해 활동 순서와 슬로건의 정보 위계를 정리했다. 엽서에는 서로 다른 AI의 특성과 아이디어가 변화·확장되는 과정을 `}</p>
          <p className="s39 s40">{`고유 색상, 투명 파이프와 구체로 담았다. 8가지 AI 가이드 카드에는 핵심 기능, 활용 분야, 프롬프트 예시, 사용 팁과 주의사항을 캐릭터와 `}</p>
          <p className="s39">{`색상으로  구분해 복잡한 정보를 친근하고 명확하게 전달했다.`}</p>
        </div>
      </div>
      <p className="s23 s2 s31 s32 s621 s27 s29 s61 s62 s54" data-node-id="875:2472">
        GRAPHIC 2
      </p>
      <div className="s2 s623 s666 s788 s625" data-node-id="875:2473" data-name="이미지 1203 2">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={img12032} />
      </div>
      <p className="s23 s2 s31 s32 s63 s27 s29 s64 s789 s66" data-node-id="875:2474">
        WORK
      </p>
      <div className="s2 s16 s17 s627 s18 s36 s63 s790 s66" data-node-id="875:2475">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2476">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2477" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s342 s9 s10 s343" src={img2026923382} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2478" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2479" />
          <p className="s23 s192 s31 s32 s667 s346 s27 s0 s198 s29 s33 s85 s668" data-node-id="875:2480">
            POSTER 1
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2481">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2482" data-name="이미지 2026. 9. 2. 오후 3.37 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s629 s630 s9 s631 s632" src={img2026923372} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s653 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2483" />
          <div className="s80 s192 s81 s69 s633 s340 s82 s0 s70 s198 s71" data-node-id="875:2484" />
          <p className="s23 s192 s31 s94 s669 s346 s27 s0 s198 s29 s33 s85 s304" data-node-id="875:2485">
            POSTER 2
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2486">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2487" data-name="이미지 2026. 9. 2. 오후 3.37 3">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s634 s635 s9 s636 s637" src={img2026923373} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2488" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2489" />
          <p className="s23 s192 s31 s94 s670 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2490">
            POSTER 3
          </p>
        </div>
      </div>
      <div className="s2 s16 s17 s627 s18 s36 s63 s791 s66" data-node-id="875:2491">
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2492">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2493" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s341 s640 s9 s641 s343" src={img2026923383} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2494" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2495" />
          <p className="s23 s192 s31 s32 s671 s346 s27 s0 s198 s29 s33 s85 s672" data-node-id="875:2496">
            POSTER 4
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2497">
          <div className="s192 s69 s673 s340 s0 s70 s198 s71" data-node-id="875:2498" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s674 s675 s9 s676 s677" src={img2026923384} />
            </div>
          </div>
          <div className="s76 s192 s344 s69 s339 s340 s0 s70 s198 s78 s79 s71" data-node-id="875:2499" />
          <div className="s80 s192 s81 s69 s647 s340 s82 s0 s70 s198 s71" data-node-id="875:2500" />
          <p className="s23 s192 s31 s94 s678 s346 s27 s0 s198 s29 s33 s85 s679" data-node-id="875:2501">
            GUIDE CARDS
          </p>
        </div>
        <div className="s335 s336 s337 s338 s0 s28" data-node-id="875:2502">
          <div className="s192 s69 s339 s340 s0 s70 s198 s71" data-node-id="875:2503" data-name="이미지 2026. 9. 2. 오후 3.38 2">
            <div className="s2 s3 s6 s4 s70">
              <img alt="" className="s2 s7 s680 s9 s10 s681" src={img2026923385} />
            </div>
          </div>
          <div className="s76 s192 s77 s69 s339 s340 s0 s70 s198 s79 s71" data-node-id="875:2504" />
          <div className="s80 s192 s81 s69 s339 s340 s82 s0 s70 s198 s71" data-node-id="875:2505" />
          <p className="s23 s192 s31 s94 s682 s346 s27 s0 s198 s29 s33 s85 s54" data-node-id="875:2506">
            POSTCARDS
          </p>
        </div>
      </div>
      <div className="s2 s102 s103 s10 s104" data-node-id="875:2507">
        <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgRectangle245} />
      </div>
      <div className="s106 s2 s16 s17 s18 s19 s683 s108 s109" data-node-id="875:2508" data-name="navigationbar">
        <div className="s16 s17 s110 s26 s0 s28" data-node-id="875:2509">
          <div className="s111 s0 s28 s112" data-node-id="875:2510" data-name="_레이어_1">
            <img alt="" className="s2 s49 s3 s9 s1" src={img1} />
          </div>
          <p className="s23 s31 s113 s32 s27 s0 s28 s29 s114 s115 s116" data-node-id="875:2515">
            DING AI LAB
          </p>
        </div>
        <div className="s16 s17 s117 s18 s0 s28" data-node-id="875:2516">
          <div className="s16 s17 s24 s118 s18 s0 s28 s119" data-node-id="875:2517">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2518">
              PROJECT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2519">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine25} />
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s123" data-node-id="875:2520">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2521">
              TEAM
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2522">
              <div className="s2 s48">
                <img alt="" className="s49 s9 s1" src={imgLine26} />
              </div>
            </div>
          </div>
          <div className="s16 s17 s24 s118 s18 s0 s28 s124" data-node-id="875:2523">
            <p className="s23 s120 s121 s32 s27 s0 s28 s29 s122 s115 s54" data-node-id="875:2524">
              ABOUT
            </p>
            <div className="s46 s0 s28 s34" data-node-id="875:2525">
              <img alt="" className="s2 s49 s3 s9 s1" src={imgLine27} />
            </div>
          </div>
        </div>
      </div>
      <div className="s106 s2 s125 s126 s10 s104" data-node-id="875:2526">
        <div className="s2 s127">
          <img alt="" className="s49 s9 s1" src={imgRectangle246} />
        </div>
      </div>
      <div className="s106 s2 s128 s126 s10 s104" data-node-id="875:2527">
        <div className="s2 s129">
          <img alt="" className="s49 s9 s1" src={imgRectangle247} />
        </div>
      </div>
      <div className="s2 s67 s153 s792" data-node-id="875:1793">
        <div className="s2 s5 s793 s153 s156 s157 s792 s158" data-node-id="856:3066" />
        <p className="s23 s2 s31 s32 s727 s27 s29 s160 s794 s54" data-node-id="856:3067">
          POSTER 4
        </p>
        <div className="s106 s2 s67 s126 s795" data-node-id="856:3082">
          <div className="s106 s2 s796 s126 s165 s4 s145 s146 s795 s522" data-node-id="856:3083">
            <div aria-hidden className="s2 s147 s3 s145" />
            <div className="s2 s3 s150 s151" />
          </div>
          <div className="s23 s2 s16 s17 s24 s167 s797 s26 s524 s27 s29 s798 s526" data-node-id="856:3084">
            <div className="s16 s17 s24 s172 s26 s0 s28 s528" data-node-id="856:3085">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3086">
                Prompt
              </p>
              <div className="s35 s36 s0 s28 s174 s34 s38" data-node-id="856:3087">
                <p className="s175 s40">Using the attached reference image as a visual style reference, develop a new set of abstract icon concepts for DING AI LAB.</p>
                <p className="s175 s40">Create 8 unique Al-related icons, each representing a different Al tool through its distinctive characteristics, thinking style, information-processing method, or creative behavior.</p>
                <p className="s175 s40">{`Do NOT use the actual logos, brand symbols, letters, or recognizable visual identities of the Al tools. Instead, translate each Al's characteristics into an abstract geometric visual system.`}</p>
                <p className="s175 s40">The icon system should follow the visual language of the reference:</p>
                <ul className="s799 s40">
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿circular outer container`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿bold, clean geometric lines`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿simple black-and-white graphic structure`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿small circular nodes or beads integrated into the structure`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿consistent line weight and visual density`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿minimal 2D vector graphic`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿highly reduced and symbolic`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿each icon should feel like part of the same unified identity system`}</span>
                  </li>
                  <li className="s800">
                    <span className="s175">{`﻿﻿strong balance between symmetry and controlled variation`}</span>
                  </li>
                </ul>
                <p className="s175 s40">{`Think of each icon as a diagram of an Al's unique way of thinking rather than a picto-gram.`}</p>
                <p className="s175 s40">For example:</p>
                <ul className="s799 s40">
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿logical and systematic thinking → straight lines, grids, linear structures`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿flexible exploration → waves, flowing paths, branching structures`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿creative expansion → spirals, radial structures, expanding forms`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿iterative refinement → repeated layers or looping structures`}</span>
                  </li>
                  <li className="s40 s800">
                    <span className="s175">{`﻿﻿fast connection and response → connected nodes and direct pathways`}</span>
                  </li>
                  <li className="s800">
                    <span className="s175">{`﻿﻿continuous transformation → circular or looping structures`}</span>
                  </li>
                </ul>
                <p className="s175 s40">{`However, do not simply copy these examples. Invent new and unexpected geometric metaphors based on each Al's characteristics.`}</p>
                <p className="s175 s40">The result should feel experimental, intelligent, playful, and contemporary, suitable for a design research community and Al experimentation lab.</p>
                <p className="s175 s40">Show the 8 icons together as a cohesive icon family, evenly spaced in one horizontal or grid arrangement, with no text or labels.</p>
                <p className="s175">Do not use actual Al logos, brand logos, recognizable brand symbols, letters, typogra-</p>
              </div>
            </div>
            <div className="s16 s17 s24 s172 s26 s0 s28 s34" data-node-id="856:3088">
              <p className="s31 s32 s0 s28 s173 s34" data-node-id="856:3089">
                AI TOOLS
              </p>
              <p className="s35 s175 s0 s28 s174 s34" data-node-id="856:3090">
                Chat GPT
              </p>
            </div>
          </div>
        </div>
        <div className="s2 s696 s801 s802 s699" data-node-id="856:3091" data-name="Untitled-1-11.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgUntitled111Png1} />
        </div>
        <div className="s2 s803 s189 s802 s804" data-node-id="856:3092" data-name="KakaoTalk_Photo_2026-09-15-00-48-36.png 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto20260915004836Png1} />
        </div>
        <div className="s2 s805 s806 s807 s808" data-node-id="856:3093" data-name="KakaoTalk_Photo_2026-09-15-15-31-55 001 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609151531550011} />
        </div>
        <div className="s2 s809 s810 s807 s811" data-node-id="856:3094" data-name="KakaoTalk_Photo_2026-09-15-15-31-56 002 1">
          <img alt="" className="s2 s3 s9 s105 s4 s1" src={imgKakaoTalkPhoto202609151531560021} />
        </div>
        <p className="s23 s2 s31 s32 s233 s27 s29 s137 s812 s54" data-node-id="856:3095">
          ICON DESIGN
        </p>
        <div className="s2 s813 s814 s815 s816" data-node-id="856:3096" data-name="에이아이랩아이콘 1">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s817 s103 s9 s818 s34" src={img2} />
          </div>
        </div>
        <div className="s2 s819 s820 s821 s822" data-node-id="856:3097" data-name="에이아이랩아이콘 2">
          <div className="s2 s3 s6 s4">
            <img alt="" className="s2 s823 s103 s9 s824 s34" src={img2} />
          </div>
        </div>
      </div>
      <div className="s2 s16 s17 s24 s130 s26 s20 s132 s133" data-node-id="875:2725" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
        <p className="s23 s31 s32 s379 s27 s0 s28 s137 s138 s380" data-node-id="875:2726">
          GRAPHIC 2
        </p>
        <div className="s16 s17 s139 s18 s0 s28 s140" data-node-id="856:3068" data-name="PROJECT_CATEGORY_TABS_GRAPHIC2">
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3069" data-name="TAB_POSTER1">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3070">
              POSTER 1
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3071" data-name="TAB_POSTER2">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3072">
              POSTER 2
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3073" data-name="TAB_POSTER3">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3074">
              POSTER 3
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <div className="s16 s81 s17 s18 s42 s142 s143 s144 s0 s145 s28" data-node-id="856:3075" data-name="TAB_POSTER4">
            <div aria-hidden className="s2 s152 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s29 s148 s54" data-node-id="856:3076">
              POSTER 4
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </div>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3077" data-name="TAB_GUIDECARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3078">
              GUIDE CARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
          <a className="s16 s141 s17 s18 s42 s142 s143 s144 s0 s145 s146 s28" data-node-id="856:3079" data-name="TAB_POSTCARDS">
            <div aria-hidden className="s2 s147 s3 s4 s145" />
            <p className="s23 s31 s32 s27 s0 s28 s148 s149 s138 s54" data-node-id="856:3080">
              POSTCARDS
            </p>
            <div className="s2 s3 s4 s150 s151" />
          </a>
        </div>
      </div>
      <button className="s2 s49 s141 s825 s212 s213" data-node-id="908:221" data-name="close">
        <img alt="" className="s2 s49 s3 s9 s1" src={imgClose} />
      </button>
    </div>
  );
}